import { SortableContext, arrayMove } from "@dnd-kit/sortable";
import { clone, findIndex } from "lodash-es";
import { Component, type ReactElement } from "react";

import { SortableItem, SortableList } from "../core/forms/Sortable.js";
import { Dialog } from "../core/overlays/Dialogs.js";
import { type ColumnAnnotation } from "@/graphql.ts";

export interface ConditionSortDialogProps {
  condition: ColumnAnnotation;

  onApply: (condition: ColumnAnnotation) => void;
  onCancel: () => void;
}

export interface ConditionSortDialogState {
  condition: ConditionSortDialogProps["condition"] | undefined;
}

class ConditionSortDialog extends Component<ConditionSortDialogProps, ConditionSortDialogState> {
  state: ConditionSortDialogState = {
    condition: undefined,
  };

  componentDidMount() {
    this.initState(this.props.condition);
  }

  initState(condition: ColumnAnnotation): void {
    this.setState({ condition: condition });
  }

  handleCancel = () => {
    this.initState(this.props.condition);
    this.props.onCancel();
  };

  handleApply = () => {
    this.state.condition && this.props.onApply(this.state.condition);
  };

  render(): ReactElement {
    const conditionValues: string[] = this.state.condition ? (this.state.condition.valueSet as string[]) : [];

    return (
      <Dialog
        headerProps={{ title: `Sort Values of Condition '${this.props.condition ? this.props.condition.name : null}'` }}
        mainActionButtonProps={{
          label: "Apply",
          onPress: this.handleApply,
        }}
        closeFn={this.handleCancel}
      >
        <SortableList
          onDragEnd={({ active, over }) => {
            const condition = { ...this.state.condition };
            const selectedSet = clone(condition.valueSet);
            const oldIndex = findIndex(selectedSet, (g) => g === active.id);
            const newIndex = findIndex(selectedSet, (g) => g === over?.id);

            if (oldIndex !== newIndex) {
              condition.valueSet = arrayMove(selectedSet as string[], oldIndex, newIndex);
              this.setState({ condition: condition as ColumnAnnotation });
            }
          }}
        >
          <SortableContext items={conditionValues}>
            {conditionValues.map((conditionValue: string, index) => (
              <SortableItem key={`item-${index}`} index={index} id={conditionValue} removeDisabled>
                <span>{conditionValue}</span>
              </SortableItem>
            ))}
          </SortableContext>
        </SortableList>
      </Dialog>
    );
  }
}

export { ConditionSortDialog };
